exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".map[data-v-a9bff9d8]{width:100%;height:720px;position:relative}#container[data-v-a9bff9d8],.background[data-v-a9bff9d8]{width:100%;height:100%;border-radius:32px;position:absolute;top:0;left:0}.background[data-v-a9bff9d8]{background-color:rgba(0,23,88,.3);pointer-events:none}.menus[data-v-a9bff9d8]{position:absolute;top:50px;right:100px}.menus .button[data-v-a9bff9d8]{float:right;background-color:#0fe6db;border:#0fe6db;color:#fff;font-weight:bolder;margin-left:20px}", ""]);

// exports
